export default __webpack_public_path__ + "static/peruHeader-767d4a95f8f3dc91a9f86b1e2074eba4.jpg";